export const getSiteAsset = ({
  type,
  path,
  fileName,
}: {
  type: 'img' | 'css' | 'fonts'
  path: string
  fileName?: string | null
}) => `/siteAssets/${type}|${path}/${fileName}`
